import { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "@/design-system/native";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { useNotificationsStore } from "../../../Components/Application/Notification/notificationsStore";
import NotificationItem from "../../../Components/Application/Notification/NotificationItem";
import { useChat } from "../../../Components/Application/Chat/chatStore";
import styles from "./Notificationbar.module.scss";

const Notificationbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const navigate = useNavigate();
  const { openConversation, openFloating } = useChat();

  const { recent = () => [], unreadCount = 0, formatRelative, markRead, markAllRead, withMeta, dispatchAction } =
    useNotificationsStore();
  const notifications = recent(6);

  const handleAction = (notif) => {
    markRead?.(notif.id);
    setDropdownOpen(false);
    const helpers = {
      navigate,
      messages: { openConversation, openFloating },
    };
    dispatchAction?.(notif, helpers);
  };

  return (
    <li className={`${styles.navItem} header-svg-icon`}>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" inNavbar>
        <div className={styles.toggleWrap}>
          <DropdownToggle tag="div" className={styles.toggle}>
            <Bell className="header-icon" />
            {unreadCount > 0 && (
              <span className="header-count-badge">{unreadCount}</span>
            )}
          </DropdownToggle>
        </div>

        <DropdownMenu end className={styles.menu}>
          <div className={styles.header}>
            <strong>Notifications</strong>
            <button
              className={styles.markAllBtn}
              onClick={() => markAllRead?.()}
            >
              Mark all as read
            </button>
          </div>

          <div className={styles.scroll}>
            {notifications.length === 0 ? (
              <div className={styles.empty}>No notification found.</div>
            ) : (
              <ul className={styles.list}>
                {notifications.map((notif) => (
                  <li
                    key={notif.id}
                    className={styles.item}
                    onClick={() => handleAction(notif)}
                  >
                    <NotificationItem
                      item={notif}
                      meta={withMeta?.(notif.type)}
                      formatRelative={formatRelative}
                      dense
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className={styles.footer}>
            <Link
              to={`${""}/notifications/Dubai`}
              className={styles.seeAll}
              onClick={() => setDropdownOpen(false)}
            >
              See All
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </li>
  );
};

export default Notificationbar;
